import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Roles } from '@models/base/identificadores.model';
import { RolDto } from '@models/seguridad/roles/rolDto.model';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { LoginService } from '@services/login/login.service';
import { PersonaService } from '@services/persona/persona.service';
import { RolService } from '@services/rol/rol.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { PersonaDetailDto } from '@models/persona/personaDetailDto.model';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InputOtpComponent } from '@component/input-otp/input-otp.component';
import { AuthLayoutComponent } from '@views/login/auth-layout/auth-layout.component';
import { CambiarContrasenaComponent } from '@views/login/cambiar-contrasena/cambiar-contrasena.component';

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors?.["confirmedValidator"]) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}
@Component({
  standalone: true,
     imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule,  A11yModule, CommonModule, MatExpansionModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, MatCheckboxModule, MatAutocompleteModule, MatChipsModule, MatTabsModule, DragDropModule, MatSidenavModule,MatListModule,InputOtpComponent,AuthLayoutComponent,CambiarContrasenaComponent],
  selector: 'app-perfil-usuario',
  templateUrl: './perfil-usuario.component.html',
  styleUrls: ['./perfil-usuario.component.css']
})
export class PerfilUsuarioComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion = new MatAccordion;
  titulo: string = '';

  subMenuActive: boolean = false;
  usuarioForm: FormGroup;
  public personaDetailDto: PersonaDetailDto = new PersonaDetailDto;
  public UsuarioDto: UsuarioDto = new UsuarioDto;
  userString: any;
  submitted = false;
  parametro: string = '';
  idTipoDocumento: number = 0;
  idEstadoCivil: number = 0;
  idPersona: number = 0;
  idUsuario: number = 0;
  idRol: number = 0;
  valor: any;
  errorMessage: string = "";
  usuarioCliente: boolean = false;
  formBuilder: FormBuilder = new FormBuilder;
  rol!: RolDto;
  get f() { return this.usuarioForm.controls; }


  constructor(
    private router: Router,
    private loginService: LoginService,
    private PersonaService: PersonaService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private RolService: RolService
  ) {

    this.usuarioForm = this.formBuilder.group({
      Nombre: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      Apellido: ['', Validators.compose([Validators.maxLength(50)])],
      Persona: [''],
      Rol: [''],
    })

  }

  ngOnInit(): void {
    const user = this.loginService.getCurrentUser()

    this.idUsuario = user.id;
    this.usuarioForm.controls["NombreUsuario"].disable();
    this.usuarioForm.controls["NombreUsuario"].setValue(user.userName)

    this.usuarioForm.controls["Persona"].disable();
    this.usuarioForm.controls["Persona"].setValue(user.nombre + ' ' +user.apellido)

    this.idRol = user.rol.id;
    this.usuarioForm.controls["Rol"].disable();

    switch (user.rol.id) {
      case Roles.SuperAdministradores:
        this.usuarioForm.controls["Rol"].setValue("Super Administradores")
        break;
      case Roles.Administradores:
        this.usuarioForm.controls["Rol"].setValue("Administradores")
        break;
      case Roles.Usuarios:
        this.usuarioForm.controls["Rol"].setValue("Usuarios")
        break;
      case Roles.Clientes:
        this.usuarioForm.controls["Rol"].setValue("Clientes")
        this.usuarioCliente = true
        break;
      default:
        break;
    }

    // if(!isFalsy(this.idRol ))
    // this.getRol(this.idRol)
  }
  getRol(id:number) {
    this.spinner.show("spRol")
    this.RolService.getById(id)
    .subscribe(
      data => {
        this.spinner.hide("spRol")
        this.usuarioForm.controls["Rol"].setValue(data.descripcion)
      },
      error => {
        this.spinner.hide("spRol")
        this.snackBar.showError(error, "Error");
      });
  }
  goToUsuarios() { }

  editarPersona() {
    this.getPersonaById(this.idPersona)
  }

  onSubmit() {
    this.submitted = true;
  }

  getPersonaById(idPersona: number) {
    this.spinner.show("spPersona")
    this.PersonaService.getPersonaById(this.idPersona)
      .subscribe(
        data => {
          this.spinner.hide("spPersona")
          this.idPersona = parseInt(data.id.toString())
          this.PersonaService.setPersona(data)
          this.router.navigate(["/personas/edit"])
        },
        error => {
          this.spinner.hide("spPersona")
          this.snackBar.showError(error, "Error");
        });
  }
}
